import React from 'react'

const PlayfairCipherTheory = () => {
    return (
        <div>
            <ul>
                <li>
                    <p>
                        The Playfair cipher was the first practical digraph substitution cipher. 
                    </p>
                </li>
                <li>
                    <p>
                        The scheme was invented in 1854 by Charles Wheatstone but was named after Lord Playfair who promoted the use of the cipher.
                    </p>
                </li>
                <li>
                    <p>
                        In playfair cipher unlike traditional cipher we encrypt a pair of alphabets(digraphs) instead of a single alphabet.
                    </p>
                </li>
                <li>
                    <p>
                        It was used for tactical purposes by British forces in the Second Boer War and in World War I and for the same purpose by the Australians during World War II. This was because Playfair is reasonably fast to use and requires no special equipment.
                    </p>
                </li>
            </ul>
        </div>
    )
}

export default PlayfairCipherTheory